import React, { useEffect, useState } from 'react'
import LoginHeader from '../Login_header'
import Menu from '../Menu'
import { Button, Col, Container, Form, Row, Table, Badge } from 'react-bootstrap'
import * as Common from "../Common";
import Dialog from '../Dialog';
import $ from "jquery";
import AsyncSelect from 'react-select/async';
import * as Picklist from '../Picklist';
import { json, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';





const Master_dsr = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');

    const [file, setFile] = useState("");
    const [dsrData, setDSRData] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [radioType, setRadioType] = useState('N');
    const [locationCode, setLocationCode] = useState("");
    const [isClickedUpload, setIsClickedUpload] = useState(false);
    const [dsrCurrency, setDsrCurrency] = useState(null);
    const [dsrProduct, setDsrProduct] = useState(null);
    const [headerData, setHeaderData] = useState([]);
    const [currencyCode, setCurrencyCode] = useState('');
    const [dsrRate, setDsrRate] = useState("");
    const [filterDsrLimit, setFilterDsrLimit] = useState('1');
    const [selectedIssuer, setSelectedIssuer] = useState(null);



    var msg = [], i = 0;


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_DSR'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedOption(value);
        console.log("Selected value:", value);
    }


    const uploadFile = () => {
        $('.loader').show();
        if (document.getElementById('importExcel').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('importExcel').files[0].name.split('.');
            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('importExcel').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else if (tempArray[1] != 'xlsx') {
                $('.loader').hide();
                setMsgText("File extension should be in xlsx format");
                setMsgBox(true);
            }
            else {

                const obj = {
                    // loc: locationCode,
                    srno: 8888,
                    uploadType: "uploadDSR",
                    pageright: "MASTER_DSR",
                    filterLimit: filterDsrLimit,
                    sid: sid,
                    file: file,
                    fromDate: Common.dateYMD(fromDate),
                    toDate: Common.dateYMD(toDate),
                    radioType: radioType,
                    selectedOption: selectedOption,
                    // loc: locationCode,
                    // allowedLocation:allowedLocation
                }
                Common.uploadApi(JSON.stringify(obj), 'importExcel', (result) => {
                    let resp = JSON.parse(result);
                    console.log(resp);
                    $('.loader').hide();
                    // setStockList(resp.docdetail.resarray);
                    // setTotalAmount(resp.docdetail.sumamount);
                    if (resp.status) {
                        setDSRData(resp.docdetail);
                        setFile('');
                        setIsClickedUpload(false);
                    }
                    setMsgBox(true);
                    setMsgText(resp.msg);
                });
            }
        }
    }

    const list = () => {

        if (!fromDate || !toDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!fromDate ? 'Select from date' : '');
            msg[i++] = (!toDate ? 'Select to date' : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                radioType: radioType,
                selectedOption: selectedOption
            }

            Common.callApi(Common.apiMasterDSR, [sid, 'showDSR', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setDSRData(resp);
            })
        }

    }

    const Lstestrate = () => {
        const obj = {
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            radioType: radioType,
            product: selectedOption,
            isd: (dsrCurrency === null ? '' : dsrCurrency.id.split('^')[1])

        }
        Common.callApi(Common.apiMasterDSR, [sid, 'showRATE', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setDSRData(resp);
        })

    }


    console.log(dsrData);

    const handleDownloadBadge = (e) => {
        e.preventDefault();
        var obj = {
            right: 'MASTER_DSR',
            product: selectedOption,
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(new Date(toDate.setDate(toDate.getDate(e) + 1)))
        }
        Common.callDownloadApiPost1(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const toggleFileHandler = () => {
        setIsClickedUpload(true);
    }


    function demodsrformatfile() {
        $(".loader").show();
        const obj = {
            location: locationCode,
            right: 'MASTER_DSR'
        }
        Common.callDownloadApiPost1(Common.apiMasterDSR, "post", [sid, 'downloadformat', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray([result]));
            setMsgBox(true);
        })
    }

    const handleCurrencyChange = (value) => {
        setDsrCurrency(value);
        const currency = value.id.split('^');
        setCurrencyCode(currency[1]);
    }

    const addData = () => {
        var msg = [], i = 0;
        if (dsrCurrency === null || dsrRate === "" || !selectedIssuer || !selectedOption) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!selectedOption ? "Product." : '');
            msg[i++] = (dsrCurrency === null ? "Currency." : '');
            msg[i++] = (dsrRate === "" ? "Rate." : '');
            msg[i++] = (!selectedIssuer ? "Issuer." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            let grp = selectedIssuer.id.split('^');
            const obj = {
                filterLimit: filterDsrLimit,
                product: selectedOption,
                isd: currencyCode,
                rate: dsrRate,
                radioType: radioType,
                groupCode: grp[1],
                accountCode: grp[2],
                selectedOption: selectedOption
            }
            Common.callApi(Common.apiMasterDSR, [sid, 'add', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                setDSRData(resp);
                setDsrCurrency(null);
                setDsrRate("");
                setSelectedIssuer(null);
            });
        }
    }


    const printDsrRate = () => {

        const obj = {
            fromDate: Common.dateYMD(fromDate),
            toDate: Common.dateYMD(toDate),
            radioType: radioType,
            product: selectedOption,
            isd: (dsrCurrency === null ? '' : dsrCurrency.id.split('^')[1])

        }
        Common.callApi(Common.apiMasterDSR, [sid, 'printrate', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setDSRData(resp.dsrrate);
            console.log("kkjjbnhjnknkj", resp);
            const newWindow = window.open('about:blank', '_blank');
            newWindow.document.write(`
                <html>
                <head>
                    <title>Master Rate</title>
                    <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    th, td  {
                        border: 2px solid black;
                        padding: 8px;
                        text-align: left;
                    }
                    
                    .header {
                        display: flex;
                        justify-content: space-between; /* Aligns items to opposite corners */
                        align-items: center; /* Vertically centers items */
                    }
                    .container{
                    background: aliceblue;
                    padding: 20px;
                    }
                    </style>
                </head>
                <body>
                     <div class="container">
                <div class="header">
                    <span>
                        ${resp.name}</br>
                        ${resp.address}<br/>
                        ${resp.place}<br/>
                        ${resp.pin}<br/>
                        ${resp.licenceType}<br/>
                        RBI Licence No.: ${resp.licenseNo} <br />
                    </span></br>       
                </div>  
                <center>
                    <h2>Master Rate</h2>
                </center>
                <table>
                    <thead>
                        <tr>
                            <th>Product</th>
                            <th>Currencies</th>
                            <th>Issuer</th>
                            <th>Rate</th>
                            <th>Timestamp</th>

                        </tr>
                    </thead>
                    <tbody>
                        ${(resp.dsrrate).map((item) => `
                        <tr>
                            <td>${item.md_product}</td>
                            <td>${item.md_isd}</td>
                            <td>${item.md_group + ' ' + item.md_account + ' ' + item.mvli_ledger_name}</td>
                            <td>${item.md_rate}</td>
                            <td>${item.md_timestamp}</td>
                        </tr>
                        `).join('')}
                    </tbody>
                </table>
            </div>
                </body>
                </html>

              `);

            newWindow.document.close();
        });

    }

    const handleIssuerChange = value => {
        setSelectedIssuer(value);
    }

    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h2>Master DSR DER</h2>
                    </Col>
                </Row>&nbsp;

                <Row>
                    <Col className='col-md-4 col-6'>
                        <Form.Group>
                            <Row style={{ marginTop: "30px" }}>
                                <Col>
                                    <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                </Col><Col>
                                    <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                </Col>
                                <Col>
                                    <Form.Check checked={radioType === "L"} onChange={() => setRadioType("L")} type='radio' label="Latest " />
                                </Col>
                            </Row>
                        </Form.Group>
                    </Col>
                </Row>&nbsp;
                {/* <Col className='col-md-3 col-6'>
                    <Form.Label>Product Filter<span className="colorThemeRed">*</span></Form.Label><br />
                    <select class="form-select" aria-label="Default select example" value={selectedOption}
                        onChange={handleSelectChange}>
                        <option value="2">EVTM</option>
                        <option value="1">VTM</option>
                    </select>
                </Col> */}
                <Row>
                    {
                        radioType === 'N' ?
                            <>
                                <Row>
                                    {
                                        userRight.add === "1" ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Product<span className="colorThemeRed">*</span></Form.Label>
                                                        <select class="form-select" aria-label="Default select example" value={selectedOption}
                                                            onChange={(e) => handleSelectChange(e)}>
                                                            <option value="">Select</option>
                                                            <option value="EVTM">EVTM</option>
                                                            <option value="VTM">VTM</option>
                                                        </select>
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Issuer<span className="text-danger">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions
                                                            defaultOptions
                                                            value={selectedIssuer}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'ISSUER', sessionStorage.getItem('hocode'))}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleIssuerChange}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Currency<span className="text-danger">*</span>
                                                        </Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={dsrCurrency}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'CN')} // location = 1 , 2
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleCurrencyChange}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Rate<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control
                                                            value={dsrRate}
                                                            onChange={(e) => Common.validateDecValue(e.target.value, setDsrRate)}
                                                            maxLength={10}
                                                            placeholder="Rate" />
                                                    </Form.Group>
                                                </Col>
                                                <Col style={{ marginTop: "34px" }}>
                                                    <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => addData()}>Add</Button>
                                                </Col>
                                            </> : null
                                    }
                                </Row>
                                <Row>&nbsp;</Row>

                                <Row>
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            {!isClickedUpload &&
                                                <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => toggleFileHandler()}>Upload</Button>}<br></br>
                                        </Col>
                                    </>
                                </Row>
                                <Row>&nbsp;</Row>

                                {isClickedUpload && <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group controlId="importExcel">
                                            <Form.Label>Upload File<span className="text-danger">*</span></Form.Label>
                                            <Form.Control type="file" value={file} onChange={e => setFile(e.target.value)} />
                                        </Form.Group>
                                    </Col>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col>
                                            <span>
                                                <Badge bg="secondary" className="handCursor" onClick={demodsrformatfile}>DSR/DER Format <FontAwesomeIcon icon={faDownload} /></Badge>
                                            </span><br></br> <br></br>
                                            <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Upload</Button>{' '}
                                        </Col>
                                    </Row>
                                </>
                                }
                            </>

                            : radioType === 'D' ?
                                <>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label><br></br>
                                            <DatePicker className="form-control"
                                                selected={fromDate}
                                                onChange={(date) => setFromDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label><br></br>
                                            <DatePicker className="form-control"
                                                selected={toDate}
                                                onChange={(date) => setToDate(date)}
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                }
                                            />

                                        </Form.Group>

                                    </Col>
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Product Filter<span className="colorThemeRed">*</span></Form.Label>
                                            <select class="form-select" aria-label="Default select example" value={selectedOption}
                                                onChange={(e) => handleSelectChange(e)}>
                                                <option value="">Select</option>
                                                <option value="EVTM">EVTM</option>
                                                <option value="VTM">VTM</option>
                                            </select>
                                        </Form.Group>
                                    </Col>
                                </>

                                :
                                radioType === 'L' ? (
                                    <>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Product Filter<span className="colorThemeRed">*</span></Form.Label>
                                                <select class="form-select" aria-label="Default select example" value={selectedOption}
                                                    onChange={(e) => handleSelectChange(e)}>
                                                    <option value="">Select</option>
                                                    <option value="EVTM">EVTM</option>
                                                    <option value="VTM">VTM</option>
                                                </select>
                                            </Form.Group><br></br>

                                        </Col><br></br>


                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Currency<span className="text-danger">*</span>
                                                </Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={dsrCurrency}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'CN')} // location = 1 , 2
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleCurrencyChange}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>

                                        <Row>
                                            <Col>
                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => Lstestrate()}>Latest Rate</Button>
                                                &nbsp;
                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => printDsrRate()} >Print</Button>
                                            </Col>
                                        </Row>
                                    </>) : null


                    }
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col >
                        {
                            userRight.add === "1" && radioType === 'N' ? <>


                                {/* {isClickedUpload && */}
                                <>
                                    {/* <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group controlId="fileExcel">
                                                    <Form.Label>Choose File<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control type="file" value={setFile} onChange={(e) => setFile(e.target.value)} />
                                                </Form.Group>
                                            </Col>
                                        </Row> */}
                                    {/* <Row>
                                        <Col>
                                            <span>
                                                <Badge bg="secondary" className="handCursor" onClick={demodsrformatfile}>DsrFormat <FontAwesomeIcon icon={faDownload} /></Badge>
                                            </span><br></br> <br></br>
                                            <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>{' '}
                                        </Col>
                                    </Row> */}
                                </>
                                {/* } */}
                            </> : null
                        }

                        &nbsp;
                        {
                            userRight.query === "1" && radioType === 'D' ? <>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()}>List</Button>
                                <span className="mx-2"><Badge bg="primary" onClick={(e) => handleDownloadBadge(e)}>Download</Badge></span>
                            </>
                                : null
                        }
                    </Col>
                </Row>

                <Row>&nbsp;</Row>

                <Row>
                    <Col>
                        <Table responsive bordered striped>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>ISD</th>
                                    <th>Issuer</th>
                                    <th>Timestamp</th>
                                    <th style={{ textAlign: 'right' }}>Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    dsrData.map((item, index) => (
                                        <tr >
                                            <td>{item.md_product}</td>
                                            <td>{item.md_isd}</td>
                                            <td>{item.md_group + ' ' + item.md_account + ' ' + item.mvli_ledger_name}</td>
                                            <td>{item.md_timestamp}</td>
                                            <td style={{ textAlign: 'right' }}>{Math.round(item.md_rate * 100000) / 100000}</td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container>

            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
        </div>

    )
}

export default Master_dsr
